import React, { lazy, Suspense } from 'react';

const LazyVr = lazy(() => import('./VR'));

const Vr = (props: React.JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <LazyVr {...props} />
  </Suspense>
);

export default Vr;
